import { createFileRoute, redirect } from "@tanstack/react-router";
import { featureFlagName } from "utils";

import { AIChatLayout } from "src/components/AIChatLayout";
import { isFeatureFlagEnabled } from "src/lib/featureFlag";
import { loaderHandler } from "src/lib/loaderHandler";

export const Route = createFileRoute("/_auth/_coach/ai")({
  component: RouteComponent,
  ssr: true,
  loader() {
    return loaderHandler((ctx) => {
      if (
        !isFeatureFlagEnabled(
          featureFlagName.aiIntegration,
          ctx.session?.user.featureFlags,
        )
      ) {
        throw redirect({ to: "/" });
      }
    });
  },
  staticData: {
    getBreadcrumb({ i18n }) {
      return {
        label: i18n.t("sidebar.ai"),
        href: "/ai",
      };
    },
  },
});

function RouteComponent() {
  return <AIChatLayout />;
}
